import { axios } from '/plugins/axios.client';
import { errorFromResponse } from '/src/common/general-utils';
import { i18n } from '/plugins/i18n.client';
const errorHandler = errorFromResponse(i18n.global.t.bind(i18n));
import { toast } from '/plugins/toaster.client.js';

export default {
  /**
   * Gets the list the categories
   * @returns {Promise<Array>} list of categories.
   */
  async getCategoriesList() {
    try {
      const data = await axios.$get('/api/appManager/getCategories');
      return data.map((category) => ({
        ...category,
        DisplayOrder: category.DisplayOrder || null
      }));
    } catch (error) {
      toast.error(errorHandler('admin.applications.actions.fetch_categories', error));
      return [];
    }
  },

  /**
   * Deletes the selected category
   * @param {string} id id of the category to be deleted.
   */
  async removeCategory(id) {
    try {
      await axios.$delete(`/api/appManager/removeCategory?id=${id}`);
      toast.success(
        i18n.global.t('admin.dynamic_labels.delete_success', {
          feature: i18n.global.t('admin.feature.application_category')
        })
      );
    } catch (error) {
      toast.error(errorHandler('admin.applications.actions.remove_category', error));
    }
  },

  /**
   * creates the category
   * @param { Object } category Details of category to be created.
   */
  async createCategory(category) {
    try {
      await axios.$post('/api/appManager/createCategory', category);
      toast.success(
        i18n.global.t('admin.dynamic_labels.create_success', {
          feature: i18n.global.t('admin.feature.application_category')
        })
      );
    } catch (error) {
      toast.error(i18n.global.t('admin.applications.category_creating_error'));
      throw Error(error);
    }
  },

  /**
   * updates the category
   * @param { Object } category Details of category to be updated.
   */
  async updateCategory(category) {
    const { id } = category;
    try {
      await axios.$put(`/api/appManager/updateCategory?id=${id}`, category);
      toast.success(
        i18n.global.t('admin.dynamic_labels.update_success', {
          feature: i18n.global.t('admin.feature.application_category')
        })
      );
    } catch (error) {
      toast.error(i18n.global.t('admin.applications.category_updating_error'));
      throw Error(error);
    }
  }
};
